import React, { useState, useContext } from "react";
import styled from "styled-components";
import PasswordStrength from "components/PasswordStrength";
import { HelpPassword, Link } from "mondrian-react";
import {
  containsMinLength,
  containsNumbers,
  containsLowercase,
  containsUppercase,
  containsSpecialCharacters,
} from "core/Utils/";
import sanitize from "core/Utils/SanitizeString";
// import { store } from "store";
const ShowTipWrapper = styled.div`
  display: flex;
`;
const PassWrapper = styled.span`
  font-size: 0.8em;
`;
export default function PasswordTips({ password, tabIndex }) {
  // const globalState = useContext(store);
  // const { state, dispatch } = globalState;
  // const currentFlow = state.analytics.flow;

  const [showTip, setShowTip] = useState(false);
  const [textLink, setTextLink] = useState("Dicas de senha");

  function updateShowtip(event) {
    event.preventDefault();
    setShowTip(!showTip);
    if (showTip) {
      setTextLink("Dicas de senha");
    } else {
      setTextLink("Ocultar dicas de senha");
    }
  }

  return (
    <>
      <ShowTipWrapper onClick={updateShowtip}>
        <Link
          href="https://cadastro.claro.com.br"
          data-gtm-event-category={`minha-claro:meu-perfil`}
          data-gtm-event-action="clique:link"
          data-gtm-event-label={sanitize(textLink)}
          target="_self"
          id="dicasSenha"
          tabIndex={tabIndex}
          title="Exibir/Ocultar dicas de senha"
        >
          <PassWrapper>{textLink}</PassWrapper>
        </Link>
      </ShowTipWrapper>

      <PasswordStrength password={password} />

      {showTip && [
        <>
          <HelpPassword
            data={[
              {
                isDone: containsLowercase(password),
                requirement: "Ao menos 1 letra minúscula",
              },
              {
                isDone: containsNumbers(password),
                requirement: "Ao menos 1 número",
              },
              {
                isDone: containsMinLength(password),
                requirement: "No mínimo 8 caracteres",
              },
            ]}
          >
            Sua senha deve ter:
          </HelpPassword>
          <HelpPassword
            data={[
              {
                isDone: containsUppercase(password),
                requirement: "Ao menos 1 letra maiúscula",
              },
              {
                isDone: containsSpecialCharacters(password),
                requirement: "Ao menos 1 caractere especial",
              },
            ]}
          >
            Recomendamos utilizar:
          </HelpPassword>
        </>,
      ]}
    </>
  );
}
